import { requestService } from 'shared/utils/services/requestService';

export const fetchSearchSuggestionsFeed = async (slug: string) => {
  return requestService({
    url: `/web-api/v1/cms/cms_articles/${slug}`,
    method: 'GET',
  });
};
